// extracted by mini-css-extract-plugin
module.exports = {"viewer":"viewer_2JLU3","videoContent":"videoContent_3Uauf"};